import axios from 'axios';

export const importStudioInvoices = async ({ newToken, file }) => {
  try {
    const response = await axios({
      method: 'post',
      url: `${process.env.REACT_APP_API_URL}/studio-invoices/import-studio-invoices`,
      data: file,
      headers: {
        Authorization: newToken,
        'Content-Type': 'multipart/form-data',
      },
    });

    if (response instanceof Error) {
      return { error: response };
    }

    return response;
  } catch (error) {
    return { error };
  }
};

const studioInvoicesAPIs = { importStudioInvoices };

export default studioInvoicesAPIs;
